export default function ListSortMark({ active, direction }) {
  return (
    <span className={`list-sort-mark${active ? ' is-active' : ''}`} aria-hidden>
      {active ? (direction === 'asc' ? '↑' : '↓') : '↕'}
    </span>
  );
}
